/* eslint-disable */
import { makeAutoObservable } from 'mobx';

class Store {
  constructor() {
    makeAutoObservable(this);
  }
  title = '';
  show = false;
  // show = true;
  closeEffect = null;
  type = 'create';
  // type = 'disabled';
  id = '';
  customerView = false; // 客户视角，客户视角下部分需求不展示

  // 设置类型
  setType(type) {
    if (type === 'edit' || type === 'disabled' || type === 'create') {
      this.type = type;
    }
  }
  // 关闭时 reset 属性
  resetData() {
    this.show = false;
    this.type = 'create';
    this.id = '';
  }

  // 创建
  createOrder() {
    this.show = true;
    this.type = 'create';
    this.customerView = false;
  }
  // 编辑
  editData(id) {
    this.id = id;
    this.show = true;
    this.customerView = false;
    this.setType('edit');
  }
  // 查看
  viewData(id, customerView = false) {
    this.id = id;
    this.show = true;
    this.customerView = customerView;
    this.setType('disabled');
  }
  // 注入的关闭 effect
  setCloseEffect(fn) {
    this.closeEffect = fn;
  }
}

export default new Store();
